import { pathOr } from 'ramda';
import * as t from './actionTypes';

const initialState = {
  loading: false,
  loaded: false,
  randomFlightUrl: '/flight-tracker/AA/100',
  airline: null,
  flightNumber: '',
  error: null,
  departureTime: 6,
  departureDate: null,
  flight: null,
  arrivalAirport: null,
  departureAirport: null,
  secondarySearchAction: false,
  secondaryAdvancedSearchAction: false,
  secondaryAdvancedSearchActionAirline: false,
  secondaryAdvancedSearchActionDepAirport: false,
  secondaryAdvancedSearchActionArrAirport: false,
  secondaryAdvancedSearchActionDepDate: false,
  secondaryAdvancedSearchActionTime: false,
  changingFlightNumberInput: false,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case t.SET_AIRLINE:
      return {
        ...state,
        airline: action.airline,
        secondaryAdvancedSearchActionAirline: action.secondaryAdvancedSearchAction,
      };
    case t.SET_ARRIVAL_AIRPORT:
      return {
        ...state,
        arrivalAirport: action.arrivalAirport,
        secondaryAdvancedSearchActionArrAirport: action.secondaryAdvancedSearchAction,
      };
    case t.SET_DEPARTURE_AIRPORT:
      return {
        ...state,
        departureAirport: action.departureAirport,
        secondaryAdvancedSearchActionDepAirport: action.secondaryAdvancedSearchAction,
      };
    case t.SET_DEPARTURE_DATE:
      return {
        ...state,
        departureDate: action.departureDate,
        secondaryAdvancedSearchActionDepDate: action.secondaryAdvancedSearchAction,
      };
    case t.SET_DEPARTURE_TIME:
      return {
        ...state,
        departureTime: action.departureTime,
        secondaryAdvancedSearchAction: action.secondaryAdvancedSearchAction,
      };
    case t.SET_FLIGHT_NUMBER:
      return {
        ...state,
        flightNumber: action.flightNumber,
        changingFlightNumberInput: true,
      };
    case t.SET_FLIGHT_TRACKER_SEARCH_ERROR:
      return {
        ...state,
        error: action.errorCode,
      };
    case t.SET_UNIVERSAL_SEARCH_FLIGHT:
      return {
        ...state,
        universalSearchValue: action.universalSearchFlight,
        secondarySearchAction: pathOr(false, ['universalSearchFlight', 'triggeredByEnter'], action),
      };
    case t.SET_SECONDARY_SEARCH_ACTION:
      return {
        ...state,
        secondarySearchAction: action.bool,
      };
    case t.SET_SECONDARY_ADVANCED_SEARCH_ACTION:
      return {
        ...state,
        secondaryAdvancedSearchAction: action.bool,
      };
    case t.SET_SECONDARY_AIRLINE:
      return {
        ...state,
        secondaryAdvancedSearchActionAirline: action.bool,
      };
    case t.SET_SECONDARY_DEP_AIRPORT:
      return {
        ...state,
        secondaryAdvancedSearchActionDepAirport: action.bool,
      };
    case t.SET_SECONDARY_ARR_AIRPORT:
      return {
        ...state,
        secondaryAdvancedSearchActionArrAirport: action.bool,
      };
    case t.SET_SECONDARY_DEP_DATE:
      return {
        ...state,
        secondaryAdvancedSearchActionDepDate: action.bool,
      };
    case t.SET_SECONDARY_TIME:
      return {
        ...state,
        secondaryAdvancedSearchActionTime: action.bool,
      };
    case t.SET_SECONDARY_ALL_BOOL:
      const { bool } = action;
      return {
        ...state,
        secondaryAdvancedSearchAction: bool,
        secondaryAdvancedSearchActionAirline: bool,
        secondaryAdvancedSearchActionDepAirport: bool,
        secondaryAdvancedSearchActionArrAirport: bool,
        secondaryAdvancedSearchActionDepDate: bool,
        secondaryAdvancedSearchActionTime: bool,
      };
    case t.SET_ADVANCED_SEARCH_URL:
      return {
        ...state,
        advancedSearchUrl: action.data.url,
      };
    case t.SET_RANDOM_FLIGHT_PATH:
      return {
        ...state,
        randomFlightPath: action.randomFlightPath,
      };
    case t.SET_FLIGHT_TRACKER_QUERY_ERROR:
      return {
        ...state,
        queryError: action.data.error,
      };
    case t.UPDATING_FLIGHT_NUMBER_INPUT:
      return {
        ...state,
        changingFlightNumberInput: action.bool,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./modules/FlightTracker/redux/Search/reducer.js